import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Loader, SearchBar, Text, Theme, QuoteCard, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import { getQuotesForReview } from '../../actions/quotes.js';
import permissionLevel from '../../services/permissions.js';

class QuotesForReview extends PureComponent {
    state = {
        query: ''
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Quotes', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        if (!this.props.quotes) {
            this.props.dispatch(getQuotesForReview(this.state.query, 0));
        }
    }

    // submit a new search, we must reset the cursor
    _search = () => {
        this.props.dispatch(getQuotesForReview(this.state.query, 0));
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _loadMore = () => {
        this.props.dispatch(getQuotesForReview(this.state.query, false));
    };

    render() {
        let { quotes } = this.props;

        if (!quotes) {
            return <Loader />;
        }

        return (
            <ContainerControlSite>
                <Header
                    subHeader="Quotes for Review"
                    selectedTitle="quotes-for-review"
                />

                <Content>
                    <SearchBar
                        onChange={(value) => this._handleInputChange('query', value)}
                        search={this._search}
                        placeholder="Search..."
                        iconColor={Theme.colors.skyBlue}
                        customStyle={{
                            margin: '20px auto',
                            width: '100%',
                            backgroundColor: Theme.colors.surface
                        }}
                    />

                    {
                        quotes.map((quote) => (
                            <QuoteCard
                                key={ quote.quoteID }
                                quote={quote} whitelabel={{}}
                                link={ `/quotes/review/${ quote.quoteID }` }
                            />
                        ))
                    }

                    {
                        quotes.length === 0 &&
                            <Text
                                testid="quotes-for-review"
                                align="center"
                                mediumLarge
                                display="block"
                            >
                                No results to display
                            </Text>
                    }

                    {
                        this.props.cursor >= 0 &&
                            <Button
                                onClick={this._loadMore}
                                color="primary"
                                marginTop={2.5}
                                fullWidth
                            >
                                Load More
                            </Button>
                    }
                </Content>
                <span id="quotes-for-review" />
            </ContainerControlSite>
        );
    }
}

QuotesForReview.propTypes = {
    accounts: PropTypes.array,
    cursor: PropTypes.number
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.loader,
    quotes: state.quotes.forReview.list,
    cursor: state.quotes.forReview.cursor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(QuotesForReview);